import { ROUTES } from '@/constants/routes.constants';

import es from './languajes/es';

const klaroConfig = {
	groupByPurpose: true,
	acceptAll: true,
	htmlTexts: true,
	disablePoweredBy: true,
	lang: 'es',
	additionalClass: 'c-pnp-klaro',
	translations: {
		zz: {
			privacyPolicyUrl: ROUTES.POLITICA_COOKIES,
		},
		es,
	},
	services: [
		{
			name: 'analytics',
			title: 'Google Analytics',
			purposes: ['analytics'],
			default: true,
		},
		{
			name: 'klaro',
			title: 'Klaro',
			purposes: ['functional'],
			required: true,
		},
	],
};

export default klaroConfig;
